module.exports = __webpack_public_path__ + "assets/spinner-ae739b.svg";